module.exports = __webpack_public_path__ + "assets/static/png/tickets-grey.17c644233acd8a8a216cff5dc38938c6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/tickets-grey.png
 ** module id = 521
 ** module chunks = 1
 **/